/**
 * Account settings page — layout (CC glass visuals from 22-overview-command-center.css).
 */

export const ACCOUNT_SETTINGS_STYLE_ID = "croc-account-settings-v4";

const ACCOUNT_SETTINGS_STYLE_TEXT = `
.acc-settings-page {
  width: 100%;
  max-width: none;
  color: var(--cc-text, var(--text, #0f172a));
  display: grid;
  grid-template-columns: minmax(200px, 220px) minmax(0, 1fr);
  gap: var(--cc-gap, 14px);
  align-items: start;
}
.acc-settings-page--no-sidebar {
  max-width: 1200px;
  margin: 0 auto;
  grid-template-columns: 1fr;
}
.acc-settings-page--no-sidebar .acc-settings-grid {
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
}
body[data-overview-cc="1"] .croc-cc-page-content .acc-settings-page {
  color: var(--cc-text);
}
.acc-settings-nav {
  position: sticky;
  top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 12px;
  max-height: calc(100dvh - 140px);
}
.acc-settings-nav__links {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.acc-settings-nav__link {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--cc-text-muted, #64748b);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.acc-settings-nav__link:hover {
  background: rgba(255, 255, 255, 0.55);
  color: var(--cc-text, #0f172a);
}
.acc-settings-nav__link--active {
  background: rgba(59, 130, 246, 0.12);
  color: var(--cc-accent, #2563eb);
  font-weight: 600;
}
.acc-settings-nav__ico {
  width: 18px;
  text-align: center;
  opacity: 0.85;
}
.acc-settings-status {
  margin-top: auto;
  padding: 12px;
}
.acc-settings-status__title {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cc-text-muted, #64748b);
}
.acc-settings-status__list {
  margin: 0;
  display: grid;
  gap: 8px;
}
.acc-settings-status__list dt {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cc-text-muted, #64748b);
}
.acc-settings-status__list dd {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--cc-text, #0f172a);
}
.acc-settings-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr) minmax(240px, 0.85fr);
  gap: var(--cc-gap, 14px);
  min-width: 0;
}
.acc-settings-col {
  display: flex;
  flex-direction: column;
  gap: var(--cc-gap, 14px);
  min-width: 0;
}
.acc-settings-panel {
  padding: 18px 20px;
}
.acc-settings-panel__title {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--cc-text-muted, #64748b);
}
.acc-settings-panel__head {
  margin: 0 0 12px;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--cc-text, #0f172a);
}
.acc-settings-profile-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}
.acc-settings-page .account-avatar-preview {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.85);
  box-shadow: 0 8px 28px rgba(59, 130, 246, 0.18);
}
.acc-settings-page .account-avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.acc-settings-page .account-avatar-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #2563eb, #6366f1);
  color: #fff;
}
.acc-settings-meta {
  flex: 1;
  min-width: 200px;
}
.acc-settings-meta .field { margin-bottom: 10px; }
.acc-settings-meta .field span {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cc-text-muted, #64748b);
}
.acc-settings-meta .field input[disabled],
.acc-settings-readonly {
  background: rgba(255, 255, 255, 0.45);
  border: 1px solid var(--cc-glass-border, rgba(255, 255, 255, 0.6));
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  color: var(--cc-text, #0f172a);
  width: 100%;
  box-sizing: border-box;
}
.acc-settings-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.acc-settings-links a,
.acc-settings-links button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 10px;
  text-decoration: none;
  color: var(--cc-text, #0f172a);
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid var(--cc-glass-border, rgba(255, 255, 255, 0.55));
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  font: inherit;
  cursor: pointer;
  text-align: left;
  appearance: none;
  -webkit-appearance: none;
}
.acc-settings-links a:hover,
.acc-settings-links button:hover {
  background: rgba(255, 255, 255, 0.65);
}
.acc-settings-nav__link {
  text-decoration: none;
}
a.acc-settings-nav__link {
  box-sizing: border-box;
}
.acc-settings-subroute {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--cc-gap, 14px);
}
.acc-settings-page--subroute {
  grid-template-columns: minmax(200px, 220px) minmax(0, 1fr);
}
.acc-settings-page--subroute .acc-settings-subroute .card,
.acc-settings-page--subroute .acc-settings-subroute .glass-panel {
  margin: 0;
}
button.settings-nav__item {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  font: inherit;
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
  color: inherit;
}
.acc-settings-hub-cards {
  display: grid;
  gap: 10px;
}
.acc-settings-hub-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  text-decoration: none;
  color: var(--cc-text, #0f172a);
  transition: background 0.15s, box-shadow 0.15s;
}
button.acc-settings-hub-card {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  font: inherit;
  text-align: left;
  cursor: pointer;
  border: inherit;
  background: inherit;
}
.acc-settings-hub-card:hover {
  background: rgba(255, 255, 255, 0.72);
}
.acc-settings-hub-card__ico {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(59, 130, 246, 0.12);
  font-size: 16px;
  flex-shrink: 0;
}
.acc-settings-hub-card__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.acc-settings-hub-card__body strong {
  font-size: 14px;
}
.acc-settings-hub-card__body .muted {
  font-size: 12px;
}
.settings-overview-stack {
  display: flex;
  flex-direction: column;
  gap: var(--cc-gap, 14px);
  min-width: 0;
}
.settings-overview-sec {
  display: flex;
  flex-direction: column;
  gap: var(--cc-gap, 14px);
  scroll-margin-top: 12px;
}
.settings-overview-sec__head {
  margin: 0;
}
.settings-overview-sec .card {
  margin: 0;
}
.acc-settings-danger {
  border-color: rgba(239, 68, 68, 0.35) !important;
}
.acc-settings-danger summary {
  cursor: pointer;
  font-weight: 700;
  color: #b91c1c;
}
/* —— Settings › User directory (CC glass — muted, no role pills) —— */
.settings-users-panel {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.settings-users-panel .ui-section-head {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--cc-glass-border, rgba(226, 232, 240, 0.65));
}
.settings-users-panel__intro {
  min-width: 0;
}
.settings-users-desc {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.45;
  max-width: 52ch;
}
.settings-users-email-strip {
  padding: 10px 14px;
  margin-bottom: 14px;
}
.settings-users-email-strip__text {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--cc-text-muted, #64748b);
}
.settings-users-email-strip__text strong {
  color: var(--cc-text, #0f172a);
  font-weight: 600;
}
.settings-users-email-strip__text code {
  font-size: 11px;
}
.settings-users-table-host {
  min-width: 0;
}
.acc-settings-page .settings-users-stats.stats {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 12px;
}
.settings-users-table-wrap {
  padding: 0;
  overflow: hidden;
}
.settings-users-table-scroll.table-wrap {
  border: none;
  border-radius: 0;
  background: transparent;
  max-height: min(520px, 60vh);
  overflow: auto;
}
.settings-users-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.settings-users-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
  background: rgba(248, 250, 252, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--cc-glass-border, rgba(226, 232, 240, 0.85));
  padding: 10px 12px;
  color: var(--cc-text-muted, #64748b);
}
.settings-users-table tbody td {
  vertical-align: middle;
  padding: 12px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.45);
  font-size: 13px;
  color: var(--cc-text, #0f172a);
}
.settings-users-table tbody tr:last-child td {
  border-bottom: none;
}
.settings-users-row {
  transition: background 0.12s ease;
}
.settings-users-row:hover {
  background: rgba(255, 255, 255, 0.45);
}
.settings-users-row--self {
  background: rgba(248, 250, 252, 0.75);
}
.settings-users-usercell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.settings-users-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #2563eb, #6366f1);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.18);
  border: 2px solid rgba(255, 255, 255, 0.85);
}
.settings-users-usercell__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.settings-users-usercell__name {
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.settings-users-you {
  align-self: flex-start;
  font-size: 10px;
  padding: 2px 6px;
}
.settings-users-email,
.settings-users-col-role,
.settings-users-col-mgr,
.settings-users-col-tenant {
  font-size: 12px;
}
.settings-users-email {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
.settings-users-col-role {
  text-transform: lowercase;
  color: var(--cc-text-muted, #64748b);
}
.settings-users-ts {
  font-size: 12px;
  color: var(--cc-text-muted, #64748b);
  white-space: nowrap;
}
.settings-users-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}
.settings-users-actions .btn.sm {
  font-size: 11px;
  padding: 5px 10px;
}
.settings-users-pol-row td {
  padding: 14px 16px !important;
  background: rgba(248, 250, 252, 0.65) !important;
}
.settings-users-empty {
  margin: 0;
  padding: 24px 16px;
  text-align: center;
}
.settings-users-table .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
@media (max-width: 900px) {
  .acc-settings-page .settings-users-stats.stats {
    grid-template-columns: 1fr;
  }
  .settings-users-col-mgr,
  .settings-users-col-tenant,
  .settings-users-table th.settings-users-col-mgr,
  .settings-users-table th.settings-users-col-tenant {
    display: none;
  }
  .settings-users-table .settings-users-col-mgr,
  .settings-users-table .settings-users-col-tenant {
    display: none;
  }
}
@media (max-width: 640px) {
  .settings-users-col-created,
  .settings-users-table th.settings-users-col-created {
    display: none;
  }
  .settings-users-table .settings-users-col-created {
    display: none;
  }
  .settings-users-email {
    max-width: 140px;
  }
}
/* —— Settings › shared admin panels —— */
.acc-settings-meta-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}
.acc-settings-meta-grid .field span {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cc-text-muted, #64748b);
}
.settings-admin-panel .ui-section-head {
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--cc-glass-border, rgba(226, 232, 240, 0.65));
}
.settings-admin-desc {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.45;
  max-width: 56ch;
}
.settings-admin-form {
  padding: 14px 16px;
  margin-bottom: 12px;
}
.settings-admin-inline-form {
  gap: 10px 12px;
}
.settings-admin-form-actions {
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}
.settings-admin-check {
  flex-direction: row !important;
  align-items: center;
  gap: 8px;
}
.settings-admin-check span {
  margin: 0;
}
.settings-admin-check input[type="checkbox"] {
  width: auto;
  margin: 0;
}
.settings-admin-hint,
.settings-admin-footnote {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}
.settings-admin-footnote {
  margin-top: 12px;
}
.settings-admin-otp {
  margin: 10px 0 0;
  font-size: 13px;
  min-height: 1.2em;
}
.settings-admin-subsec {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid rgba(226, 232, 240, 0.65);
}
.settings-admin-subsec:first-of-type {
  margin-top: 12px;
  padding-top: 0;
  border-top: none;
}
.settings-admin-subsec__title {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--cc-text, #0f172a);
}
.settings-admin-list-host {
  min-width: 0;
}
.settings-admin-status-host {
  margin-bottom: 12px;
}
.settings-admin-status-strip {
  padding: 12px 14px;
}
.settings-admin-status-strip--err {
  border-color: rgba(239, 68, 68, 0.25);
}
.settings-admin-status-note {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.45;
  word-break: break-word;
}
.settings-admin-kv-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px 14px;
  margin: 0;
}
.settings-admin-kv-grid--steps {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.settings-admin-kv {
  margin: 0;
}
.settings-admin-kv__k {
  margin: 0 0 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cc-text-muted, #64748b);
}
.settings-admin-kv__v {
  margin: 0;
  font-size: 13px;
  color: var(--cc-text, #0f172a);
  word-break: break-word;
}
.settings-admin-empty {
  margin: 0;
  padding: 20px 14px;
  text-align: center;
  font-size: 13px;
}
.settings-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.settings-admin-table-wrap {
  padding: 0;
  overflow: hidden;
}
.settings-admin-table-scroll.table-wrap,
.settings-admin-table-wrap .table-wrap {
  border: none;
  border-radius: 0;
  background: transparent;
}
.settings-admin-table-scroll {
  max-height: min(420px, 55vh);
  overflow: auto;
}
.settings-admin-table {
  width: 100%;
}
.settings-admin-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
  background: rgba(248, 250, 252, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--cc-glass-border, rgba(226, 232, 240, 0.85));
  padding: 10px 12px;
  color: var(--cc-text-muted, #64748b);
}
.settings-admin-table td {
  vertical-align: middle;
  padding: 12px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.45);
  font-size: 12.5px;
}
.settings-admin-table tbody tr:last-child td {
  border-bottom: none;
}
.settings-admin-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.45);
}
.settings-admin-row--muted {
  opacity: 0.72;
}
.settings-admin-mini-stats {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 10px;
}
.settings-admin-mini-stats .v {
  font-size: 18px;
}
.settings-admin-col-device {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.settings-admin-col-email {
  word-break: break-all;
  max-width: 220px;
}
.settings-admin-panel--ops .settings-admin-backup-key {
  max-width: 480px;
  margin: 0 0 12px;
}
.settings-admin-backup-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.settings-admin-file-btn {
  position: relative;
  cursor: pointer;
  margin: 0;
}
.settings-admin-file-btn input[type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}
.settings-tg-link-host {
  margin-top: 0;
}
@media (max-width: 900px) {
  .settings-admin-col-by,
  .settings-admin-table th:nth-child(7) {
    display: none;
  }
  .settings-admin-table .settings-admin-col-by {
    display: none;
  }
  .acc-settings-meta-grid {
    grid-template-columns: 1fr;
  }
  .settings-admin-kv-grid--steps {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 1100px) {
  .acc-settings-page {
    grid-template-columns: 1fr;
  }
  .acc-settings-nav {
    position: static;
    max-height: none;
  }
  .acc-settings-nav__links {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .acc-settings-grid,
  .acc-settings-page--no-sidebar .acc-settings-grid {
    grid-template-columns: 1fr;
  }
}
`;

export function ensureAccountSettingsStyles() {
  if (typeof document === "undefined") return false;
  if (document.getElementById(ACCOUNT_SETTINGS_STYLE_ID)) return true;
  const el = document.createElement("style");
  el.id = ACCOUNT_SETTINGS_STYLE_ID;
  el.textContent = ACCOUNT_SETTINGS_STYLE_TEXT;
  document.head.appendChild(el);
  return true;
}

export function removeAccountSettingsStyles() {
  if (typeof document === "undefined") return;
  const el = document.getElementById(ACCOUNT_SETTINGS_STYLE_ID);
  if (el) el.remove();
}
